"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var requiredFields = ['title', 'description'];

function _default() {
  var postItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var assetId = postItem.assetId,
      embedCode = postItem.embedCode,
      sourceLink = postItem.sourceLink;
  var isVideoAdded = assetId || embedCode && sourceLink;
  return Boolean(isVideoAdded) && requiredFields.every(function (field) {
    return Boolean(postItem[field]);
  });
}